import moment from "moment"

import { FieldValidator } from "./"

export const validateDateOfBirth: FieldValidator = value => {
  const MAX_AGE = 115

  if (value) {
    const clearDob = value.replace(/ /g, "")
    const enteredDate = moment(clearDob, "MM/DD/YYYY", true)
    const yearsDiff = moment().diff(enteredDate, "years", true)
    const isLegalAge = yearsDiff < MAX_AGE

    if (!enteredDate.isValid() || !isLegalAge) {
      return "Please enter a valid date."
    }
  }

  return null
}
